import { TESTID_BUTTONS, TESTID_TOP_BAR } from 'Constants/testids';
import { useSoftphoneStore } from 'Modules/softphone/store';
import React from 'react';
import { Styled } from './index.styles';

export const DialpadIconButton: React.FC = () => {
  const { isDialpadActive, isTransferActive, setDialpadActive, cancelTransfer } =
    useSoftphoneStore((state) => ({
      isDialpadActive: state.isDialpadActive,
      isTransferActive: state.isTransferActive,
      setDialpadActive: state.setDialpadActive,
      cancelTransfer: state.cancelTransfer,
    }));

  const handleOpenDialpad = () => {
    if (isTransferActive) {
      cancelTransfer();
      setDialpadActive(true);
      return;
    }
    setDialpadActive(!isDialpadActive);
  };

  return (
    <Styled.IconButton
      content="Dial pad"
      compact
      icon="dialpad"
      onClick={handleOpenDialpad}
      popupPosition="bottom center"
      size="medium"
      testid={TESTID_TOP_BAR['BAR'] + TESTID_BUTTONS['DIAL_PAD']}
      variant="secondary"
      active={isDialpadActive}
    />
  );
};
